import { FC } from "react";
import { GenericAppThemeProperty } from "../Types";
import { Grid } from "@material-ui/core";
import BehaviorPropertyCard from "../Cards/BehaviorPropertyCard";

type BehaviorPropertiesListProps = {
  propertiesList: GenericAppThemeProperty[];
};

const BehaviorPropertiesList: FC<BehaviorPropertiesListProps> = ({ propertiesList }) => {
  const sortedProps = [...propertiesList].sort((a, b) =>
    a.propertyLabel.toLowerCase().localeCompare(b.propertyLabel.toLowerCase())
  );

  return (
    <Grid container spacing={2} sx={{ padding: "1%" }}>
      {sortedProps.map((property) => (
        <Grid item xs={12} sm={12} md={6} lg={4} xl={3} key={property.themePropertyMasterKey}>
          <BehaviorPropertyCard property={property} />
        </Grid>
      ))}
    </Grid>
  );
};

export default BehaviorPropertiesList;
